module.exports = __webpack_public_path__ + "static/media/now.6b9e6834.png";